import { useListContext } from 'react-admin';
import { Box, Paper, Typography } from '@mui/material';
import { __t } from '../../i18n/t';
import { ErrorCard, SkeletonCard, fmtNum, useDashboardSection } from '../dashboards/shared';

interface Funnel {
  total: number; pending: number; seen: number; dismissed: number; superseded: number;
  active: number; ended: number; endedExpired: number; endedConverted: number;
  activatedEver: number; continueRequested: number;
}

/** Funil dos convites; acompanha o período (criado de/até) e o lançamento do filtro da lista (o backend não filtra o funil por rede/status). */
const FunnelCard = () => {
  const { filterValues } = useListContext();
  // Mesmo dataProvider das demais telas: GET /attendant-goal-offers/funnel?filter={...}, resposta em data[0].
  const { data, loading, error, refetch } = useDashboardSection<Funnel>('attendant-goal-offers/funnel', {
    createdFrom: filterValues.createdFrom,
    createdTo: filterValues.createdTo,
    rollout: filterValues.rollout,
  });

  if (error) { return <Box sx={{ mb: 2 }}><ErrorCard height={96} onRetry={refetch} /></Box>; }
  if (loading && !data) { return <Box sx={{ mb: 2 }}><SkeletonCard height={96} /></Box>; }
  if (!data) { return null; }

  const tiles: Array<{ label: string; value: string; hint?: string }> = [
    { label: __t('Criados'), value: fmtNum(data.total) },
    { label: __t('Aguardando resposta'), value: fmtNum(data.pending) },
    { label: __t('Vistos'), value: fmtNum(data.seen) },
    { label: __t('Agora não'), value: fmtNum(data.dismissed) },
    { label: __t('Em degustação'), value: fmtNum(data.active), hint: __t('%{n} já ativaram', { n: data.activatedEver }) },
    {
      label: __t('Encerrados'), value: fmtNum(data.ended),
      hint: __t('%{e} prazo vencido · %{c} viraram contrato', { e: data.endedExpired, c: data.endedConverted }),
    },
    { label: __t('Pediram para continuar'), value: fmtNum(data.continueRequested) },
    { label: __t('Fechados sozinhos'), value: fmtNum(data.superseded) },
  ];

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
        {__t('Todas as redes, no período e lançamento filtrados')}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
        {tiles.map(t => (
          <Paper key={t.label} variant="outlined" sx={{ px: 2, py: 1.25, minWidth: 140 }}>
            <Typography variant="h5" component="div" sx={{ fontWeight: 600, lineHeight: 1.2 }}>{t.value}</Typography>
            <Typography variant="body2" color="text.secondary">{t.label}</Typography>
            {t.hint && <Typography variant="caption" color="text.secondary">{t.hint}</Typography>}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default FunnelCard;
